
pyzel.newsletter = {

    subscription: $( function(){

        $('#subscribe-newsletter-btn').on('click', e =>{
            
            e.preventDefault();                    
            
            let name = $('#subscribe-newsletter-form #name').val();    
            let email = $('#subscribe-newsletter-form #email').val();
            
            if( name != '' && /(.+)@(.+){2,}\.(.+){2,}/.test( email ) ){

                $.ajax({

                    url: endpoint+'/subscribers',
                    method: 'post',
                    contentType: 'application/json',
                    dataType: 'json',            
                    data: JSON.stringify( {

                        name, 
                        email                

                    } )

                }).done( r => {                    

                    $('#subscribe-newsletter-form input').fadeOut();

                    $('#subscribe-newsletter-btn').off('click');

                    $('#subscribe-newsletter-btn').html('you are subscribed!').addClass('btn-success disabled');

                }).fail( e => {

                    console.log( e );

                    alert('an error occured while communicating with the server');

                })
                
            }else{
             
                alert('please check invalid fields');
                
                // add some visual feedback - not defined on the design
                //$('#subscribe-newsletter-form #email').parent('.form-group').addClass('has-error');
                
            }        
            
        })

    })

};